// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"205":"16d759cd","284":"0c512169","800":"3db18181"}[chunkId] + ".css";
};